// Adds the signed-in user's Supabase token to every same-origin /api/ request that doesn't already carry one, so API
// routes can check who is calling. The token is refreshed first when it is about to run out, and a 401 gets one silent
// refresh + retry (src/lib/freshToken.js) - also for the pages that set their own Authorization header.
import { supabase } from './supabase'
import { fetchWithLogin } from './freshToken'
import { openVesselId } from './openVessel'

// the vessel open in the app (src/lib/openVessel.js) as X-HC-Vessel, unless the call names one itself
export function withVessel(input, init, id = openVesselId()) {
  if (!id) return init
  const h = new Headers(init.headers || (typeof input !== 'string' && input && input.headers) || undefined)
  if (!h.has('X-HC-Vessel')) h.set('X-HC-Vessel', id)
  return { ...init, headers: h }
}

if (typeof window !== 'undefined' && !window.__hcAuthFetch) {
  window.__hcAuthFetch = true
  const orig = window.fetch.bind(window)
  window.fetch = async (input, init) => {
    let api = false
    try {
      const url = typeof input === 'string' ? input : (input && input.url) || ''
      api = url.startsWith('/api/') || url.startsWith(window.location.origin + '/api/')
    } catch (e) { /* never block the request */ }
    if (!api) return orig(input, init)
    return fetchWithLogin(orig, supabase, input, withVessel(input, init || {}))
  }
}
